module.exports = __webpack_public_path__ + "static/media/styledChevromRight.e8ea544e.svg";